import type { ComponentType, PropsWithChildren } from 'react';
import React from 'react';

import FormGroupRow from './FormGroupRow';

type FormGroupProps<Props extends object> = Props & {
  className?: string;
  Component: ComponentType<Props>;
};

const FormGroup = <Props extends object = any>({
  children,
  className,
  Component,
  ...restProps
}: PropsWithChildren<FormGroupProps<Props>>) => (
  <FormGroupRow className={className}>
    <Component {...(restProps as unknown as Props)} />
    {children}
  </FormGroupRow>
);

export default FormGroup;
